import { getFunctions, httpsCallable } from "firebase/functions";
import { Firebase } from "../FirebaseApp";
import { toast } from "react-toastify";
import { ErrorHelper } from "../helpers/ErrorHelper";

export const ManualSubscriptionController = {
    functions: getFunctions(Firebase),

    /**
     * Create a manual subscription for a user who paid offline
     * @param {Object} data - Subscription data
     * @param {string} data.userId - User ID
     * @param {string} data.planId - Plan ID (just the ID, not full path)
     * @param {string} data.priceId - Price ID (just the ID, not full path)
     * @param {number} data.durationMonths - Duration in months
     * @param {number} data.paymentAmount - Payment amount
     * @param {string} data.paymentMethod - Payment method (e.g., 'bank_transfer', 'pix', 'cash')
     * @param {string} data.paymentReference - Payment reference/transaction ID
     * @param {string} data.notes - Additional notes
     * @param {Function} res - Success callback
     */
    CreateManualSubscription: async function (data, res) {
        try {
            const createManualSubscription = httpsCallable(this.functions, "createManualSubscription");
            const response = await createManualSubscription(data);
            console.log("Manual subscription created successfully:", response.data);
            toast.success("Assinatura manual criada com sucesso!");
            res(response.data);
        } catch (error) {
            console.error("Error creating manual subscription:", error.message);
            toast.error("Erro ao criar assinatura manual: " + ErrorHelper.HandleMessage(error));
            throw error;
        }
    },

    /**
     * Extend an existing manual subscription
     * @param {Object} data - Extension data
     * @param {string} data.userId - User ID
     * @param {number} data.extensionMonths - Number of months to extend
     * @param {number} data.paymentAmount - Payment amount
     * @param {string} data.paymentReference - Payment reference/transaction ID
     * @param {string} data.notes - Additional notes
     * @param {Function} res - Success callback
     */
    ExtendManualSubscription: async function (data, res) {
        try {
            const extendManualSubscription = httpsCallable(this.functions, "extendManualSubscription");
            const response = await extendManualSubscription(data);
            console.log("Manual subscription extended successfully:", response.data);
            toast.success("Assinatura manual estendida com sucesso!");
            res(response.data);
        } catch (error) {
            console.error("Error extending manual subscription:", error.message);
            toast.error("Erro ao estender assinatura manual: " + ErrorHelper.HandleMessage(error));
            throw error;
        }
    },

    /**
     * Cancel a manual subscription
     * @param {Object} data - Cancellation data
     * @param {string} data.userId - User ID
     * @param {boolean} data.cancelImmediately - Whether to cancel immediately or at period end
     * @param {string} data.notes - Cancellation notes
     * @param {Function} res - Success callback
     */
    CancelManualSubscription: async function (data, res) {
        try {
            const cancelManualSubscription = httpsCallable(this.functions, "cancelManualSubscription");
            const response = await cancelManualSubscription(data);
            console.log("Manual subscription canceled successfully:", response.data);
            toast.success("Assinatura manual cancelada com sucesso!");
            res(response.data);
        } catch (error) {
            console.error("Error canceling manual subscription:", error.message);
            toast.error("Erro ao cancelar assinatura manual: " + ErrorHelper.HandleMessage(error));
            throw error;
        }
    }
};